import { render, staticRenderFns } from "./searchKnowledge.vue?vue&type=template&id=af7ad09a&scoped=true&"
import script from "./searchKnowledge.vue?vue&type=script&lang=js&"
export * from "./searchKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./searchKnowledge.vue?vue&type=style&index=0&id=af7ad09a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ad09a",
  null
  
)

export default component.exports